import React from 'react';
import { useFadeIn } from '../hooks/useFadeIn';
export function ProblemSection() {
  const fadeIn = useFadeIn();
  return <section className="py-10 md:py-16 px-4 bg-black text-white border-y-8 border-red-600" data-id="element-225">
      <div className="max-w-3xl mx-auto" data-id="element-226">
        <div ref={fadeIn.ref} className={`space-y-6 md:space-y-8 text-base md:text-xl ${fadeIn.className}`} data-id="element-227">
          <div className="text-center mb-8 md:mb-12" data-id="element-228">
            <h2 className="text-2xl md:text-4xl font-black text-yellow-400 mb-4 md:mb-6" data-id="element-229">
              💔 Do Any Of These Sound Familiar?
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 max-w-3xl mx-auto" data-id="element-230">
            <div className="bg-gray-900 p-5 md:p-6 rounded-xl border border-gray-700 shadow-lg" data-id="element-231">
              <div className="text-3xl md:text-4xl mb-3 md:mb-4" data-id="element-232">📱</div>
              <p className="text-gray-300 font-medium" data-id="element-233">
                Screens are the only thing that keeps them calm — and that guilt
                never goes away.
              </p>
            </div>
            <div className="bg-gray-900 p-5 md:p-6 rounded-xl border border-gray-700 shadow-lg" data-id="element-234">
              <div className="text-3xl md:text-4xl mb-3 md:mb-4" data-id="element-235">🥱</div>
              <p className="text-gray-300 font-medium" data-id="element-236">
                You buy activity books that last three days and end up forgotten
                in a drawer.
              </p>
            </div>
            <div className="bg-gray-900 p-5 md:p-6 rounded-xl border border-gray-700 shadow-lg" data-id="element-237">
              <div className="text-3xl md:text-4xl mb-3 md:mb-4" data-id="element-238">😤</div>
              <p className="text-gray-300 font-medium" data-id="element-239">
                Every homework session ends in tears, arguments or "I can't do
                this."
              </p>
            </div>
            <div className="bg-gray-900 p-5 md:p-6 rounded-xl border border-gray-700 shadow-lg" data-id="element-240">
              <div className="text-3xl md:text-4xl mb-3 md:mb-4" data-id="element-241">⏳</div>
              <p className="text-gray-300 font-medium" data-id="element-242">
                You can see your child is smart — but they can't show it because
                they lose focus before finishing.
              </p>
            </div>
          </div>

          <div className="text-center mt-8 md:mt-12 space-y-3 md:space-y-4" data-id="element-243">
            <p className="text-xl md:text-2xl font-bold text-white" data-id="element-244">
              It's not a lack of effort. It's that nobody taught their brain how
              to work.
            </p>
            <p className="text-xl md:text-2xl font-bold text-yellow-400" data-id="element-245">
              School teaches children WHAT to think. Nobody teaches them HOW to
              think.
            </p>
            <p className="text-gray-300 max-w-2xl mx-auto mt-3 md:mt-4" data-id="element-246">
              That gap shows up every single day — in the frustration, the
              meltdowns, the "I give up," and the endless screen battles.
            </p>
          </div>

          <div className="bg-gray-900 p-6 md:p-8 rounded-xl border border-yellow-500 mt-8 md:mt-12 shadow-2xl" data-id="element-247">
            <div className="space-y-4 md:space-y-6 text-gray-300" data-id="element-248">
              <p className="flex items-start gap-3" data-id="element-249">
                <span className="text-xl md:text-2xl" data-id="element-250">🔑</span>
                <span className="font-bold text-white" data-id="element-251">
                  What your child needs isn't more content. They need a system
                  that trains their brain progressively — area by area — until
                  everything works together.
                </span>
              </p>
              <p className="flex items-start gap-3" data-id="element-252">
                <span className="text-xl md:text-2xl" data-id="element-253">🧠</span>
                <span data-id="element-254">
                  The Little Genius System™ gives you 310 pages of
                  brain-building activities designed by experts to develop real
                  cognitive skills.
                </span>
              </p>
              <p className="flex items-start gap-3" data-id="element-255">
                <span className="text-xl md:text-2xl" data-id="element-256">✨</span>
                <span className="font-bold text-yellow-400" data-id="element-257">
                  What if this week was the turning point where your child
                  finally showed everything they're truly capable of?
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}